import axiosInstance from './axiosInstance';

export const getAllTickets = async () => {
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  if (!epicxTenantId) {
    throw new Error('Tenant ID is missing');
  }

  const response = await axiosInstance.get(
    `/orders/api/tickets/${epicxTenantId}`
  );

  return response.data.tickets || [];
};

export const updateTicket = async (ticketNo, payload) => {
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  if (!epicxTenantId) {
    throw new Error('Tenant ID is missing');
  }

  const response = await axiosInstance.put(
    `/orders/api/tickets/${epicxTenantId}/${encodeURIComponent(ticketNo)}`,
    payload
  );

  return response.data;
};
